import { render, staticRenderFns } from "./CampaignsWidget.vue?vue&type=template&id=df287d5c&scoped=true"
import script from "./CampaignsWidget.vue?vue&type=script&lang=js"
export * from "./CampaignsWidget.vue?vue&type=script&lang=js"
import style0 from "./CampaignsWidget.vue?vue&type=style&index=0&id=df287d5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df287d5c",
  null
  
)

export default component.exports